import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromProfile from '../reducers/owner.reducer';

export const getOwner = createSelector(
  fromFeature.getOwnerState,
  fromProfile.getOwner
);

export const getOwnerLoaded = createSelector(
  fromFeature.getOwnerState,
  fromProfile.getOwnerLoaded
);

export const getOwnerLoading = createSelector(
  fromFeature.getOwnerState,
  fromProfile.getOwnerLoading
);
